(() => {
  class CardSizeSelect extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);

      // Cards with size buttons show the selected size's own price (not the "from" price).
      // The observer also catches size changes made by the color-swatch swap.
      this.priceObserver = new MutationObserver(() => this.syncPrice());
      this.priceObserver.observe(this, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.syncPrice(), { once: true });
      } else {
        this.syncPrice();
      }
    }

    disconnectedCallback() {
      this.priceObserver?.disconnect();
    }

    syncPrice(sizeBtn = this.querySelector('[data-variant-id].is-selected')) {
      const price = sizeBtn?.dataset.variantPrice;
      const card = this.closest('product-card, horizontal-product-card');
      const priceEl = card?.querySelector('[data-card-price-value]');
      if (price && priceEl && priceEl.innerHTML !== price) priceEl.innerHTML = price;
    }

    handleClick = (event) => {
      const sizeBtn = event.target.closest('[data-variant-id]');
      if (!sizeBtn || sizeBtn.disabled) return;
      event.preventDefault();

      const card = this.closest('product-card, horizontal-product-card');
      const variantInput = card?.querySelector('.product-card__add input[name="id"]');
      if (variantInput) variantInput.value = sizeBtn.dataset.variantId;

      this.querySelectorAll('[data-variant-id]').forEach((btn) => {
        const isSelected = btn === sizeBtn;
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });

      this.syncPrice(sizeBtn);
    };
  }

  if (!customElements.get('card-size-select')) {
    customElements.define('card-size-select', CardSizeSelect);
  }
})();
